<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  sendResults: { type: Object, default: null },
  status: { type: String, default: '' },
});

const { t } = useI18n();

const total = computed(() => props.sendResults?.total || 0);
const sent = computed(() => props.sendResults?.sent || 0);
const failed = computed(() => props.sendResults?.failed || 0);

const sentPct = computed(() =>
  total.value > 0 ? (sent.value / total.value) * 100 : 0
);
const failedPct = computed(() =>
  total.value > 0 ? (failed.value / total.value) * 100 : 0
);

const hasResults = computed(() => props.sendResults && total.value > 0);

const label = computed(() => {
  if (!hasResults.value) {
    if (props.status === 'scheduled')
      return t('CAMPAIGN.DASHBOARD.DELIVERY.SCHEDULED');
    if (props.status === 'active' || props.status === 'sending')
      return t('CAMPAIGN.DASHBOARD.DELIVERY.SENDING');
    return t('CAMPAIGN.DASHBOARD.DELIVERY.WAITING');
  }
  return t('CAMPAIGN.DASHBOARD.DELIVERY.RESULT', {
    sent: sent.value,
    total: total.value,
    failed: failed.value,
  });
});
</script>

<template>
  <div class="w-full min-w-[120px]">
    <div
      v-if="hasResults"
      class="flex h-2 rounded-full overflow-hidden bg-n-solid-3"
    >
      <div
        class="bg-n-teal-9 transition-all"
        :style="{ width: sentPct + '%' }"
      />
      <div
        class="bg-n-ruby-9 transition-all"
        :style="{ width: failedPct + '%' }"
      />
    </div>
    <div v-else class="flex h-2 rounded-full overflow-hidden bg-n-solid-3">
      <div
        v-if="status === 'sending'"
        class="bg-n-blue-9 animate-pulse w-1/3"
      />
    </div>
    <div class="text-[11px] text-n-slate-9 mt-1 leading-none">
      {{ label }}
    </div>
  </div>
</template>
